// extracted by mini-css-extract-plugin
export var image = "ExternalArticlesSlider-module--image--ad39e";
export var link = "ExternalArticlesSlider-module--link--ca5ca";
export var slide = "ExternalArticlesSlider-module--slide--bedf5";
export var slider = "ExternalArticlesSlider-module--slider--22967";